/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rules_Kind_Tournament_TitleInputs */



/**
* | output |
* | --- |
* | "Tournament Rules" |
*
* @param {Rules_Kind_Tournament_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const rules_kind_tournament_title = /** @type {((inputs?: Rules_Kind_Tournament_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rules_Kind_Tournament_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Turnierregeln")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles de tournoi")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("赛事规则")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("賽事規則")
	if (locale === "ko") return /** @type {LocalizedString} */ ("대회 규정")
	return /** @type {LocalizedString} */ ("Tournament Rules")
});